/* eslint-disable */
let ieVersion = (() => {
  let sAgent = window.navigator.userAgent;
  let Idx = sAgent.indexOf("MSIE");

  // If IE, return version number.
  if (Idx > 0)
    return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));

  // If IE 11 then look for Updated user agent string.
  else if (!!navigator.userAgent.match(/Trident\/7\./))
    return 11;
  else
    return null; //It is not IE
})()
/* eslint-enable */

export default {
  /**
   * @returns {boolean} is current browser IE
   */
  isIE () {
    return ieVersion !== undefined
  },

  /**
   * Returns IE version. For example, on IE9 returns 9.
   * @returns {undefined|number} version of IE
   */
  getIEVersion () {
    return ieVersion
  },

  install (Vue) {
    Vue.prototype.$browser = this
  }
}



// WEBPACK FOOTER //
// ./src/utils/Browser.js